export enum ResourceType {
  Database = 'database',
  DatabaseProperty = 'property',
  DatabaseItem = 'database-item',
  Workspace = 'workspace',
  DatabaseView = 'database-view',
  Conversation = 'conversation',
  Dashboard = 'dashboard',
  CallRoom = 'call-room',
  DashboardItem = 'dashboard-item',
  Folder = 'folder',
  Automation = 'automation',
  AutomationVersion = 'automation-version',
  AutomationRun = 'automation-run',
  DatabaseSlice = 'database-slice',
  ResourceGroup = 'resource-group',
  CloudItem = 'cloud-item',
  DirectConversation = 'direct-conversation',
  ResourceSpace = 'resource-space',
  App = 'app',
  AppAutomation = 'automation-app-item',
  ResourceItem = 'resource-item',
  WebhookListenerDefinition = 'webhook-listener-definition',
  WebhookListener = 'webhook-listener',
  Connection = 'connection',
  ConnectionDefinition = 'connection-definition',
  DynamicFieldDefinition = 'dynamic-field-definition',
  Cron = 'cron',
  Document = 'document',
  Skill = 'skill',
  Agent = 'agent',
  Whiteboard = 'whiteboard',
  /**
   * Not a permission subject — cell attachments are governed by their column's and item's permissions.
   * The member exists so a global-search result can name what it is; nothing creates ResourceItems or
   * permission schema entries for it.
   */
  DatabaseItemFile = 'database-item-file',
}
